import type { SubscriptionPlanType } from '@repo/subscription/api';
import {
  subscriptionStoreSelector,
  useSubscriptionStore,
} from '@repo/subscription/client';

import { PricingPlanValue } from '../../../types/Pricing';
import { getPlanPrice } from '../utils';

const usePlanPrice = ({
  plan,
  isYearly,
}: {
  plan: SubscriptionPlanType;
  isYearly: boolean;
}): PricingPlanValue => {
  const country = useSubscriptionStore(
    subscriptionStoreSelector.requestCountry
  );

  const subscriptionPrices = useSubscriptionStore(
    subscriptionStoreSelector.subscriptionPrices
  );

  return getPlanPrice({
    plan,
    isYearly,
    subscriptionPrices,
    country,
  });
};

export default usePlanPrice;
